// extracted by mini-css-extract-plugin
module.exports = {"allData":"ActivityDetail_allData__1KFVi","detail":"ActivityDetail_detail__2MYHR","p":"ActivityDetail_p__38CPh"};